export default value => !(value || '').toString().match(/[^\d+\s\-/]/g)
